import React, { useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper'
import { CommonModal, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite'
import { getAllDriver, getBankListApi } from '_services'
import toast from 'react-hot-toast'
import { UserContext } from 'context'

const formObj = {
    driver: null,
}

const bankValidationSchema = {
    driver: {
        required: true,
        message: "Please select a driver"
    }
}

const DriverSelectModal = (props) => {
    const { setDriverDetails, driverDetails, onSubmit, isLoadding, nextModal } = props;

    const { globTripDetails } = useContext(UserContext)
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const initialDriverIdRef = React.useRef(driverDetails?.driver?._id || null);
    const driverType = globTripDetails?.vehicle_ownership == 2 ? 2 : 1;

  
    const fetchDriver = async (search, page, limit) => {
        if (loading) return { items: [], total: 0 };

        setLoading(true);

        try {
            const res = await getAllDriver({
                company_id: StorageService.getCompanyId(),
                firm_id: globTripDetails?.interfirm ? globTripDetails?.vehicle_firm?._id : globTripDetails?.firm_id?._id,
                offset: page,
                limit,
                search,
                driver_type: driverType

            });

            if (res?.responseCode === 200) {
                setLoading(false);
                const list = await res?.data?.driver_list
                    // ?.filter((i) => i?.driver_type == 2)
                    .map((i) => ({
                        ...i,
                        name: i?.name,
                        label: i?.name,
                        value: i?._id
                    }))

                return {
                    items: list,
                    total: res?.data?.total_record,
                };
            } else {
                setLoading(false);
                toast.error(res?.responseMessage);
            }

        } catch (error) {
            toast.error("Error fetching drivers");
            return { items: [], total: 0 };
        } finally {
            setLoading(false);
        }
    };

    const validateForm = (data) => {
        const errors = {};

        if (!data.driver || !data.driver || !data.driver._id) {
            errors.driver = bankValidationSchema.driver.message;
        }

        return errors;
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...driverDetails, [name]: item };
        setDriverDetails(stateObj);

        if (formError[name] && item) {
            const updatedErrors = { ...formError };
            delete updatedErrors[name];
            setFormError(updatedErrors);
        }
    };

    const handleSubmit = () => {

        const errors = validateForm(driverDetails);
        if (Object.keys(errors).length > 0) {
            setFormError(errors)
            return;
        }
        setFormError({});
        if (onSubmit) {
            onSubmit();
        }
    };


    const addNewDriver = () => {
        nextModal()
    }
    const modalProps = {
        ...props,
        onSubmit: handleSubmit,
        // disabled: !driverDetails?.driver?._id || initialDriverIdRef.current == driverDetails?.driver?._id||isLoadding ,
        disabled: !driverDetails?.driver?._id || isLoadding,
        isLoadding: isLoadding,
    };

    return (
        <div>
            <CommonModal {...modalProps}>
                <div className='addLr_body'>
                    <SingleSelectDropdownInfinite
                        label="Select Driver"
                        fetchData={fetchDriver}
                        selectedItem={driverDetails?.driver}
                        onChange={(data) => onhandleSelect(data, "driver")}
                        error={!!formError.driver}
                        errorMessage={formError.driver}
                        pageSize={20}
                        placeholder="Choose a Driver..."
                        required={true}
                        isAddButton={true}
                        addButtonAction={addNewDriver}
                    />

                    {/* Optional: Show validation message */}

                </div>
            </CommonModal>
        </div>
    )
}

export default DriverSelectModal